import React from "react";
import { Select } from "antd";
// import { ChevronDown } from "../../icons";
import style from "./select.module.css";

const MultipleSelect = (props) => {
  return (
    <div
      className={`  ${props.isError ? ` ${style.MultipleSelectError} ` : `${MultipleSelect}`} ${style.MultipleSelectWidth} ${
        props.loading ? ` ${style.MultipleSelectLoadingChildren}` : `${style.MultipleSelectChildren}`
      }  ${style.MultipleSelect}  ${style.MultipleSelectChildrenCloseIcon} ${style.MultipleSelectChildrenCloseIconDiv} ${style.MultipleSelectOverflow} ${style.ActionChecked} ${style.MultipleSelectRemoveClose}`}
    >
      <Select
        className={props.styleComponent}
        // showSearch={true}
        mode="multiple"
        showArrow={true}
        status={props.status}
        // suffixIcon={<ChevronDown />}
        optionFilterProp="children"
        optionLabelProp="value"
        // // placeholder={"10 of 20 items"}
        menuItemSelectedIcon={null}
        {...props}
      >
        {props.option}
      </Select>
    </div>
  );
};

export default MultipleSelect;
